import request from '@/utils/request'

// 查询分组标签列表分页
export function fetchList(query) {
    return request({
        url: '/taxation/prod/tag/reference/page',
        method: 'get',
        params: query,
    })
}
// 查询分组标签详细
export function getObj(id) {
    return request({
        url: '/taxation/user/tenant/detail?id=' + id,
        method: 'get',
    })
}
//  审核
// 分组标签
export function addObj(data) {
    return request({
        url: '/taxation/prod/tag/reference/add',
        method: 'post',
        data: data,
    })
}
// 禁用启用 维修首页状态
export function statusObj(data) {
    return request({
        url: '/taxation/user/tenant/status',
        method: 'post',
        data: data,
    })
}
// 修改分组标签
export function putObj(data) {
    return request({
        url: '/taxation/user/tenant/edit',
        method: 'post',
        data: data,
    })
}
// 删除分组标签
export function delObj(data) {
    return request({
        url: '/taxation/prod/tag/reference/delete',
        method: 'post',
        data: data,
    })
}
